import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const PAGE_META = {
  "/about":   { title: "About Us",        subtitle: "Our story, mission, and the team building the future of global payments." },
  "/blog":    { title: "Blog",            subtitle: "Insights on cross-border payments, financial inclusion, and product updates." },
  "/careers": { title: "Careers",         subtitle: "Join our team and help build infrastructure for the global diaspora." },
  "/press":   { title: "Press",           subtitle: "Media resources, brand assets, and press contact." },
  "/docs":    { title: "Developer Docs",  subtitle: "API reference, SDKs, and integration guides for MoneyMeet Pay." },
};

export default function ComingSoon() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const meta = PAGE_META[pathname] ?? { title: "Coming Soon", subtitle: "This page is on its way." };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#030910",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 24px",
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      {/* Logo */}
      <div style={{ marginBottom: "56px" }}>
        <Logo variant="dark" size="md" />
      </div>

      {/* Content card */}
      <div
        style={{
          background: "#0C1526",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "24px",
          padding: "56px 48px",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 32px 80px rgba(0,0,0,0.5)",
        }}
      >
        {/* Pill */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            background: "rgba(16,185,129,0.10)",
            border: "1px solid rgba(16,185,129,0.20)",
            borderRadius: "100px",
            padding: "5px 14px",
            marginBottom: "28px",
          }}
        >
          <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#10B981", display: "inline-block" }} />
          <span style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#10B981" }}>
            Coming Soon
          </span>
        </div>

        {/* Title */}
        <h1
          style={{
            fontSize: "clamp(28px, 5vw, 36px)",
            fontWeight: 900,
            fontFamily: "'Fraunces', Georgia, serif",
            color: "#ffffff",
            marginBottom: "16px",
            lineHeight: 1.15,
          }}
        >
          {meta.title}
        </h1>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "15px",
            lineHeight: 1.65,
            color: "rgba(255,255,255,0.42)",
            marginBottom: "40px",
            maxWidth: "340px",
            margin: "0 auto 40px",
          }}
        >
          {meta.subtitle}
        </p>

        {/* Divider */}
        <div
          style={{
            height: "1px",
            background: "rgba(255,255,255,0.06)",
            marginBottom: "32px",
          }}
        />

        {/* CTA row */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "13px 28px",
              borderRadius: "100px",
              background: "rgba(255,255,255,0.07)",
              border: "1px solid rgba(255,255,255,0.10)",
              color: "rgba(255,255,255,0.70)",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "background 0.18s, color 0.18s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.12)";
              e.currentTarget.style.color = "rgba(255,255,255,0.90)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.07)";
              e.currentTarget.style.color = "rgba(255,255,255,0.70)";
            }}
          >
            <ArrowLeft size={15} strokeWidth={2.2} />
            Go back
          </button>

          <button
            onClick={() => navigate("/")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "13px 28px",
              borderRadius: "100px",
              background: "linear-gradient(135deg, #10B981 0%, #0D9368 100%)",
              border: "none",
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: 700,
              cursor: "pointer",
              transition: "opacity 0.18s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.88"; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
          >
            Back to home
          </button>
        </div>
      </div>

      {/* Footer note */}
      <p
        style={{
          marginTop: "36px",
          fontSize: "12px",
          color: "rgba(255,255,255,0.18)",
          textAlign: "center",
        }}
      >
        © 2025 Mikkshebs System Technology S.R.L.
      </p>
    </div>
  );
}
